// extracted by mini-css-extract-plugin
module.exports = {"root":"Navbar_root__QgVqp","link":"Navbar_link__teYe1","link-sm":"Navbar_link-sm__VtM_Z","logo":"Navbar_logo__INhgK","linkSub":"Navbar_linkSub__ejmJv"};